import {Injectable} from '@angular/core'
import {BehaviorSubject, Observable} from 'rxjs'

@Injectable()
export class UserGuideService {

  opened: boolean
  height = (() => {
    return document.body.clientHeight
  })()
  private pageAvailable: BehaviorSubject<boolean>

  constructor() {
    this.pageAvailable = new BehaviorSubject<boolean>(false)
  }
  setValue(newValue: boolean): void {
    this.pageAvailable.next(newValue)
  }
  getValue(): Observable<boolean> {
    return this.pageAvailable.asObservable()
  }

  open() {
    this.opened = true
  }

  close() {
    this.opened = false
  }

}
